/**
 * External dependencies
 */
import styled from '@emotion/native';

/**
 * Internal dependencies
 */
import { text } from './styles/text-mixins';

const Text = styled.Text( text );

export default Text;
